import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

@Component({
  selector: 'restoreid-not-found',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  public dashboardUrl = '/dashboard';
  constructor(
    private _topBarService: TopBarService,
  )
  {
    this._topBarService.setTitle('Not Found');
  }
}
